import { LocalComponent } from "~/ecs/base"

export class WallVisible extends LocalComponent {}
